import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useInfrastructureChartsDataContext } from './hooks/useInfrastructureChartsDataContext';

export const ExternalWallMeterial = () => {
    const { chartData } = useInfrastructureChartsDataContext();


    return (
        <SimpleBars
            title={'Material Predominante da Parede Externa'}
            horizontal={true}
            subtitles={chartData?.externalWallMeterial?.map((item) => item.description)}
            values={chartData?.externalWallMeterial?.map((item) => item.total  ||  0)}
        />
    );
};
